import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiYoutube, FiInstagram, FiMail, FiPhone, FiExternalLink } from 'react-icons/fi';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const socialLinks = [
        { icon: FiFacebook, href: "https://www.facebook.com/MathematicsWithManoj", color: 'hover:bg-blue-600' },
        { icon: FiTwitter, href: "#", color: 'hover:bg-[#1DA1F2]' },
        { icon: FiYoutube, href: "#", color: 'hover:bg-[#FF0000]' },
        { icon: FiInstagram, href: "#", color: 'hover:bg-[#E4405F]' }
    ];

    const curriculumLinks = [
        { name: 'Theory Synergies', path: '#' },
        { name: 'Revision Protocols', path: '#' },
        { name: 'Paper Class Matrix', path: '#' },
        { name: 'Student Enrollment', path: '#' }
    ];

    const labLinks = [
        { name: 'Digital Library', path: '/study-materials' },
        { name: 'Student Gallery', path: '/gallery' },
        { name: 'Scientific Paradigm', path: '#' },
        { name: 'Academic Portal', path: '/login' }
    ];

    return (
        <footer className="bg-[#050505] pt-32 pb-16 px-6 border-t border-white/[0.03] relative overflow-hidden">
            {/* Top Glow Line */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[1px] bg-gradient-to-r from-transparent via-blue-500/50 to-transparent"></div>

            <div className="max-w-7xl mx-auto relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-12 mb-24">
                    {/* Brand Section */}
                    <div className="space-y-8">
                        <Link to="/" className="inline-block group">
                            <div className="text-2xl font-black text-white tracking-tighter transition-all duration-300 group-hover:tracking-normal">
                                MANOJ <span className="text-blue-500">SAMPATH</span>
                            </div>
                            <div className="text-[10px] font-black text-neutral-600 uppercase tracking-widest mt-2 border-t border-white/5 pt-2">
                                Mathematics - English Medium
                            </div>
                        </Link>
                        <p className="text-sm text-neutral-500 font-medium leading-relaxed max-w-xs">
                            Pioneering a hybrid education paradigm that merges traditional brilliance with digital precision.
                        </p>
                        <div className="flex gap-3">
                            {socialLinks.map((social, i) => (
                                <a
                                    key={i}
                                    href={social.href}
                                    className={`w-11 h-11 rounded-xl bg-white/[0.03] border border-white/[0.08] flex items-center justify-center text-neutral-500 hover:text-white transition-all duration-500 ${social.color} hover:border-transparent`}
                                >
                                    <social.icon className="text-lg" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Navigation 1 */}
                    <div>
                        <h3 className="text-white font-black uppercase tracking-[0.3em] text-[10px] mb-10">Curriculum</h3>
                        <ul className="space-y-5">
                            {curriculumLinks.map((link, i) => (
                                <li key={i}>
                                    <a href={link.path} className="text-sm font-bold text-neutral-500 hover:text-blue-500 transition-colors flex items-center gap-3 group">
                                        <span className="w-1 h-1 rounded-full bg-blue-500 scale-0 group-hover:scale-100 transition-transform"></span>
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Navigation 2 */}
                    <div>
                        <h3 className="text-white font-black uppercase tracking-[0.3em] text-[10px] mb-10">The Lab</h3>
                        <ul className="space-y-5">
                            {labLinks.map((link, i) => (
                                <li key={i}>
                                    {link.path.startsWith('/#') ? (
                                        <a href={link.path} className="text-sm font-bold text-neutral-500 hover:text-white transition-colors flex items-center gap-3">
                                            {link.name}
                                        </a>
                                    ) : (
                                        <Link to={link.path} className="text-sm font-bold text-neutral-500 hover:text-white transition-colors flex items-center gap-3">
                                            {link.name}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Section */}
                    <div>
                        <h3 className="text-white font-black uppercase tracking-[0.3em] text-[10px] mb-10">Headquarters</h3>
                        <div className="space-y-8">
                            <div className="flex gap-4">
                                <div className="w-10 h-10 rounded-xl bg-blue-600/10 flex items-center justify-center shrink-0">
                                    <FiPhone className="text-blue-500 text-sm" />
                                </div>
                                <div>
                                    <p className="text-white font-black text-sm">071 4336294</p>
                                    <span className="text-[10px] font-black text-neutral-600 uppercase tracking-widest block mt-1">Direct Line</span>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="w-10 h-10 rounded-xl bg-blue-600/10 flex items-center justify-center shrink-0">
                                    <FiMail className="text-blue-500 text-sm" />
                                </div>
                                <div>
                                    <p className="text-white font-black text-sm">manojsampath.maths@gmail.com</p>
                                    <span className="text-[10px] font-black text-neutral-600 uppercase tracking-widest block mt-1">Official Email</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            {/* Bottom Bar Container */}
            <div className="pt-10 border-t border-white/[0.03]">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 md:gap-0">
                    <div className="flex flex-col md:flex-row items-center gap-8 text-center md:text-left">
                        <p className="text-neutral-600 text-[9px] font-black uppercase tracking-[0.2em]">
                            © {currentYear} MANOJ SAMPATH ACADEMICS.
                        </p>
                        <div className="flex gap-8">
                            <Link to="/privacy" className="text-neutral-600 hover:text-white text-[9px] font-black uppercase tracking-[0.2em] transition-colors">Privacy</Link>
                            <Link to="/terms" className="text-neutral-600 hover:text-white text-[9px] font-black uppercase tracking-[0.2em] transition-colors">Terms</Link>
                        </div>
                    </div>
                    <div className="flex flex-wrap justify-center items-center gap-4">
                        <a
                            href="https://www.facebook.com/profile.php?id=61587040271390"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 px-5 py-2.5 rounded-full border border-white/5 bg-white/[0.02] shadow-inner hover:bg-white/[0.05] transition-all group"
                        >
                            <span className="text-[9px] font-black text-white/20 tracking-[0.2em] uppercase">Powered By</span>
                            <div className="flex items-center gap-2">
                                <img src="/hero/logostt.PNG" alt="Sat Tech" className="w-10 h-10" />
                                <span className="text-[10px] font-black text-white tracking-[0.1em] uppercase">Sat Tech</span>
                            </div>
                            <FiExternalLink size={10} className="text-white/20 group-hover:text-white transition-colors" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
